export default {
  setAuth(state, auth) {
    state.auth = auth;
  },

  setExpiredDays(state, { days, status }) {
    state.expired.days = days;
    state.expired.status = status;
  },
};



// WEBPACK FOOTER //
// ./src/stores/auth/mutations.js